export const educationData = [
    {
        id: 1,
        institution: 'Govt School Asareta Pawar',
        course: 'Higher Secondary Education',
        startYear: '2005',
        endYear: '2017'
    },
    {
        id: 2,
        institution: 'Sarvodaya Public School Talen',
        course: '10+2 High Education',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'Motilal Nehru Institute Of Technology Allahabad',
        course: 'Bechelor of Technology(B.TECH)',
        startYear: '2020',
        endYear: 'Present'
    },
]